import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac1000',
    ecrans: ['00-2'],
    params: ['?etccleint']
});
